import React from 'react'

import { Segment, SegmentButton, GridRow } from '@mytours/components'

import './styles/segmentButtons.less'

interface Props {
	onChange: (value: string) => void
	selectedValue: string
	buttons: {
		value: string
		label: string
	}[]
}

// The library's Segment is a headless radio group, so the label is the button's own child rather
// than a nested label, and `mode="ios"` is gone — the rounded pill this control wants comes from
// segmentButtons.less, not from an Ionic platform mode.
const SegmentButtons = ({ onChange, selectedValue, buttons }: Props): JSX.Element => (
	<GridRow className="segment-controls-container">
		<div className="segment-controls-row">
			<Segment value={selectedValue} onValueChange={onChange}>
				{buttons.map(({ value, label }) => (
					<SegmentButton key={value} value={value}>
						{label}
					</SegmentButton>
				))}
			</Segment>
		</div>
	</GridRow>
)

export default SegmentButtons
